import React from "react";
import IconToggle from "../../UI/Header/IconToggle";
import { useSelector } from "react-redux";
import Profile from "../../UI/Header/Profie";
import NotificationBell from "../../UI/Notifications/NotificationBell";
import {useNavigate} from "react-router-dom";
import ChatNotificationBell from "../../UI/Notifications/ChatNotificationBell";

const Head = ({ toggleTheme, thememode }) => {
  const toggle = useSelector((state) => state.Sidebar.toggle);
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // This goes back one step in history
  };

  return (
    <nav
      className={`pr-[30px] flex items-center h-[4rem] duration-500 bg-secondary dark:bg-darkPrimary ${
        toggle
          ? "!justify-end  w-full md:pl-[285px]"
          : "pl-[30px]"
      }`}
    >
      <button
          onClick={handleGoBack}
          className="absolute top-4 left-4 z-10 flex items-center justify-center w-10 h-10 bg-white bg-opacity-20 hover:bg-opacity-30 rounded-full transition-all duration-200 shadow-md backdrop-blur-sm"
          aria-label="Go back"
      >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-black"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
        </svg>
      </button>
      <div className="flex justify-between items-center z-30 gap-x-2">
        {/* Theme Toggle Button */}
        <button
          onClick={toggleTheme}
          className="p-2 rounded-full bg-secondary dark:bg-darkPrimary"
        >
          {thememode === "light" ? "🌙" : "☀️"}
        </button>
        {/* <Notification /> */}
        <Profile />
        <NotificationBell />
        <ChatNotificationBell />
      </div>
    </nav>
  );
};

export default Head;
